export default "/_next/static/src/assets/videos/86f5d5215752f3a4a9cfd35863ad2fe0.mp4";